module.exports = __webpack_public_path__ + "img/offeo-7.c24b69e0.png";